import { render, staticRenderFns } from "./KnowHowPopUp.vue?vue&type=template&id=1f1ffd65&scoped=true&"
import script from "./KnowHowPopUp.vue?vue&type=script&lang=js&"
export * from "./KnowHowPopUp.vue?vue&type=script&lang=js&"
import style0 from "./KnowHowPopUp.vue?vue&type=style&index=0&id=1f1ffd65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ffd65",
  null
  
)

export default component.exports